// ** Toolkit imports
import { configureStore } from '@reduxjs/toolkit'

// ** Reducers
import channel from 'src/store/apps/channel'
import lookup from 'src/store/apps/lookup'
import calendar from 'src/store/apps/calendar'
import alert from 'src/store/apps/alert'
import campaign from './apps/campaign'

export const store = configureStore({
    reducer: {
        channel,
        lookup,
        calendar,
        alert,
        campaign
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: false
        })
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
